import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    WucAlertModule, WucBalloonModule,
    WucButtonModule, WucDisplayFieldModule,
    WucFormFieldLabelModule,
    WucFormFieldModule, WucFormFieldSubtextModule,
    WucIconModule, WucInputAlertModule, WucInputLicensePlateNlModule, WucInputRadioModule,
    WucInputTextModule, WucLinkModule, WucListModule,
} from '@inshared/website-ui-components';
import { OutInternationalMotorInsuranceCardModule } from 'outshared-lib';
import {
    InsuranceIMICButtonDownloadComponent,
    InsuranceIMICButtonEmailComponent,
    InsuranceIMICButtonsComponent,
    InsuranceIMICCarComponent,
    InsuranceIMICCaravanComponent,
    InsuranceIMICMopedComponent,
    InsuranceIMICMotorcycleComponent,
    InsuranceIMICVehicleComponent,
    InsuranceIMICComponent,
} from './';
import { ReactiveFormsModule } from '@angular/forms';
import { KentekenModule, CapitalizeModule } from '@inshared/shared/util-pipes';

@NgModule({
    imports: [
        CommonModule,
        OutInternationalMotorInsuranceCardModule,
        ReactiveFormsModule,
        WucIconModule,
        WucFormFieldModule,
        WucFormFieldLabelModule,
        WucInputTextModule,
        WucInputRadioModule,
        WucInputAlertModule,
        WucButtonModule,
        WucAlertModule,
        WucDisplayFieldModule,
        WucLinkModule,
        WucBalloonModule,
        WucListModule,
        WucInputLicensePlateNlModule,
        WucFormFieldSubtextModule,
        KentekenModule,
        CapitalizeModule,
    ],
    declarations: [
        InsuranceIMICVehicleComponent,
        InsuranceIMICButtonsComponent,
        InsuranceIMICComponent,
        InsuranceIMICButtonDownloadComponent,
        InsuranceIMICButtonEmailComponent,
        InsuranceIMICCarComponent,
        InsuranceIMICCaravanComponent,
        InsuranceIMICMopedComponent,
        InsuranceIMICMotorcycleComponent,
    ],
    exports: [
        InsuranceIMICVehicleComponent,
        InsuranceIMICButtonsComponent,
        InsuranceIMICComponent,
        InsuranceIMICButtonDownloadComponent,
        InsuranceIMICButtonEmailComponent,
        InsuranceIMICCaravanComponent,
    ],
})
export class InsuranceIMICModule {
}
